import { memo } from "react";

function DeleteUser() {
   return <>DeleteUser</>;
}

export default memo(DeleteUser);
